import { render, staticRenderFns } from "./calculation.vue?vue&type=template&id=4a5f41bc&"
import script from "./calculation.vue?vue&type=script&lang=js&"
export * from "./calculation.vue?vue&type=script&lang=js&"
import style0 from "./calculation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports